import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { Observable, tap, timer } from 'rxjs';
import { SvgWorkspaceComponent } from '../../../../components/svg-workspace/svg-workspace.component';
import { CuttingCustomHole } from '../../../../models/cutting/cutting-custom-hole.model';
import { CuttingFixedFastenersSet } from '../../../../models/cutting/cutting-fixed-fasteners-set.model';
import { CuttingPanel } from '../../../../models/cutting/cutting-panel.model';
import { CuttingPanelListService } from '../../cutting-panel-list.service';
import { FastenersBySides } from '../panel-outline-editor-dialog.component';

@Component({
  selector: 'csl-fasteners-form',
  templateUrl: './fasteners-form.component.html',
  styleUrls: ['./fasteners-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FastenersFormComponent implements OnInit {
  selectedCustomFastener: CuttingCustomHole[];
  selectedFastenersSet: CuttingFixedFastenersSet;

  render$: Observable<number>;

  @Input() editable = true;
  @Input() panel: CuttingPanel;
  @Input() mainMaterialThickness = 0;

  @Output() formCustomHolesChanged: EventEmitter<FastenersBySides> = new EventEmitter();

  @ViewChild('svgWorkspace', { static: true }) svgWorkspace: SvgWorkspaceComponent;

  @HostBinding('class.fasteners-form-wrapper')
  fastenersFormWrapper = true;

  constructor(public dialog: MatDialog, private cuttingPanelListService: CuttingPanelListService) {}

  ngOnInit(): void {
    /* TODO: Т к раньше это делалось в ngAfterViewChecked, это очень перегружало основной поток и вызывало циклические рендеры,
     * чтобы ничего не поломать и снизить нагрузку добавлен этот костыль,
     * но перерисовку все равно необходимо переделать, чтобы схема перерисовывалась только при реальных изменениях в панели
     */
    this.render$ = timer(0, 1000).pipe(
      tap(() => {
        this.redraw();
      })
    );
  }

  redraw(): void {
    this.svgWorkspace.draw(this.panel);
  }

  customFastenersChange(customHoles: FastenersBySides): void {
    this.formCustomHolesChanged.next(customHoles);

    this.redraw();
  }

  onSelectedCustomHole(hole: CuttingCustomHole[] | undefined): void {
    this.selectedFastenersSet = undefined;
    this.selectedCustomFastener = hole;
  }

  onSelectedFastenersSet(item: CuttingFixedFastenersSet): void {
    this.selectedCustomFastener = undefined;
    this.selectedFastenersSet = item;
  }
}
